module.exports = __webpack_public_path__ + "static/media/img94.3ff1644d.jpg";